import React from 'react';
import { 
	func,
	array
} from 'prop-types';
import {ErrorTooltip} from '../../molecules/Tooltip';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import style from './style';

const Presenter = ({tags,value,onKeyPress,onChange,onRemove,onKeyDown,error,t,...props}) => {
	const tagComponents = tags && tags.map(tag=><style.Tag 
		onRemove={()=>{onRemove(tag);}}
		key={tag} text={tag}/>);
	const inputComponent = <style.TextInput placeholder={t('create-quiz.InputTag')} 
		value={value}
		onKeyPress={onKeyPress}
		onKeyDown={onKeyDown}
		onChange={onChange}
	/>;
	return <style.Wrapper {...props}>
		{tagComponents}
		{
			error !== '' ? <ErrorTooltip text={error}>
				{inputComponent}
			</ErrorTooltip> : inputComponent
		}
	</style.Wrapper>;
};

Presenter.propTypes = {
	tags : array,
	onEnter : func,
	onRemove : func,
};

export default withNamespaces()(Presenter);